import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "link-library-20", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M15 8.5a3.5 3.5 0 0 1 0 7h-5a3.5 3.5 0 0 1 0-7h1.5" }),
        React.createElement("path", { d: "M5 11.5a3.5 3.5 0 0 1 0-7h5a3.5 3.5 0 0 1 0 7H8.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
